import { Input } from 'antd'
import FormItem from 'antd/es/form/FormItem'

/*
 * @Author: Tina Huang
 * @Date: 2024-08-29 17:45:47
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2024-09-03 22:45:02
 * @Description:
 */
export default function LuckinForm() {
  return (
    <>
      <FormItem label="取餐编号" name="orderNumber">
        <Input placeholder="如：98777" />
      </FormItem>
      <FormItem label="订单模式" name="orderMode">
        <Input placeholder="如：外送 第1/2杯" />
      </FormItem>
      <FormItem label="下单昵称" name="orderName">
        <Input placeholder="如：咖啡免费的啾啾" />
      </FormItem>
      <FormItem label="订单商品" name="orderContent">
        <Input placeholder="如：生椰丝绒拿铁" />
      </FormItem>
      <FormItem label="客制化" name="orderCus">
        <Input placeholder="如：无奶油" />
      </FormItem>
      <FormItem label="下单时间" name="orderTime">
        <Input placeholder="如：2024/08/28 12:11" />
      </FormItem>
    </>
  )
}
